import React from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { coloresEmma } from '../../../global/js/funciones';

const CargandoInter = ({ mensaje = 'Cargando...', marginTop = '7%' }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    style={{ marginTop, marginBottom: '3%' }}
  >
    <CircularProgress size={70} thickness={4} style={{ color: coloresEmma.primarycolor }} />
    <Typography variant="body1" style={{ marginTop: 16, fontWeight: 'bold', color: coloresEmma.colornegro }}>
      {mensaje}
    </Typography>
  </Box>
);

export default CargandoInter;
